export const glassCard = 'rounded-xl backdrop-blur-md bg-glass ring-1 ring-glass-ring'

export const innerCard = 'rounded-lg bg-glass-inner ring-1 ring-glass-ring-inner'
